/**
 * Dynamically add routes based on the list defined in ./routes.ts,
 * can be customized to meet your use case
 */
import { Route, Routes } from "react-router";

import { useRootContext } from "@client/context/RootContext";

import { routes } from "./routes";

export const Router = () => {
	const {
		layoutStore: { isDashboardActive },
	} = useRootContext();
	const _routes = routes();

	return (
		<Routes>
			{_routes.map((route) => (
				<Route
					key={route.path}
					path={route.path}
					element={<route.component />}
				/>
			))}
		</Routes>
	);
};
